import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8dedda82af2851e/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/app/[locale]/online-ordering-webshop/WebshopPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8dedda82af2851e/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8dedda82af2851e/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8dedda82af2851e/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8dedda82af2851e/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8dedda82af2851e/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8dedda82af2851e/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
